
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apply-press",
      function () {
        return require("private-next-pages/apply-press.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apply-press"])
      });
    }
  